function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Ebene_2"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Ebene_1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "arrow",
  d: "M34.54,27.34 28.59,33.12 28.59,18 25.89,18 25.89,33.11 19.95,27.34 18.06,29.27 27.24,38.2 36.42,29.27z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_5_2_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M27.5,55C12.34,55,0,42.66,0,27.5C0,12.34,12.34,0,27.5,0C42.66,0,55,12.34,55,27.5C55,42.66,42.66,55,27.5,55z  M27.5,2.7C13.83,2.7,2.7,13.82,2.7,27.5s11.13,24.8,24.8,24.8s24.8-11.13,24.8-24.8S41.18,2.7,27.5,2.7z"
})))));

function SvgBlickfangIconCircleArrowBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlickfangIconCircleArrowBlack);
export default __webpack_public_path__ + "static/media/Blickfang_Icon-circle-arrow-black.bc954623.svg";
export { ForwardRef as ReactComponent };